import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import onPaste from './handlers/onPaste';
import onCopy from './handlers/onCopy';
import onCut from './handlers/onCut';
import htmlSerializer from './serializers/htmlSerializer';
import textSerializer from './../../utils/textSerializer';
import markdownSerializer from './serializers/markdownSerializer';
import getFragmentFromEvent from './utils/getFragmentFromEvent';
export default function ClipboardPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$getFullNotePath = _ref.getFullNotePath,
      getFullNotePath = _ref$getFullNotePath === void 0 ? function (x) {
    return x;
  } : _ref$getFullNotePath;

  var serializers = [];
  var deserializers = [];
  return [{
    onConstruct: function onConstruct(editor, next) {
      var _editor$controller$mi = editor.controller.middleware,
          _editor$controller$mi2 = _editor$controller$mi.serializers,
          middlewareSerializers = _editor$controller$mi2 === void 0 ? [] : _editor$controller$mi2,
          _editor$controller$mi3 = _editor$controller$mi.deserializers,
          middlewareDeserializers = _editor$controller$mi3 === void 0 ? [] : _editor$controller$mi3;
      serializers = middlewareSerializers.reduce(function (_ref2, rule) {
        var html = _ref2.html,
            markdown = _ref2.markdown;
        return {
          html: _objectSpread({}, html, {}, rule.html || {}),
          markdown: _objectSpread({}, markdown, {}, rule.markdown || {})
        };
      }, {
        html: {},
        markdown: {}
      });
      deserializers = middlewareDeserializers.reduce(function (memo, rule) {
        return _objectSpread({}, memo, {}, rule);
      }, {});
      return next();
    },
    queries: {
      getSerializingRules: function getSerializingRules() {
        return serializers;
      },
      getDeserializingRules: function getDeserializingRules() {
        return deserializers;
      },
      getFragmentFromEvent: getFragmentFromEvent,
      serializeFragmentAsMarkdown: function serializeFragmentAsMarkdown(editor, fragment) {
        return markdownSerializer(editor, {
          getFullNotePath: getFullNotePath
        })(fragment);
      },
      serializeFragmentAsText: function serializeFragmentAsText(editor, fragment) {
        return textSerializer(editor, {
          getFullNotePath: getFullNotePath
        })(fragment);
      },
      serializeFragmentAsHtml: function serializeFragmentAsHtml(editor, fragment) {
        return htmlSerializer(editor, {
          getFullNotePath: getFullNotePath
        })(fragment);
      }
    },
    commands: {
      copyFragmentToClipboard: function copyFragmentToClipboard(editor, event, fragment) {
        var text = editor.serializeFragmentAsText(fragment);
        event.clipboardData.setData('text/plain', text);
        var html = editor.serializeFragmentAsHtml(fragment);
        event.clipboardData.setData('text/html', html); // The world is not ready for this
        // const markdown = editor.serializeFragmentAsMarkdown(fragment)
        // event.clipboardData.setData('text/markdown', markdown)

        event.preventDefault();
      }
    }
  }, _objectSpread({
    onPaste: onPaste
  }, onCopy({
    getFullNotePath: getFullNotePath
  }), {}, onCut({
    getFullNotePath: getFullNotePath
  }))];
}
ClipboardPlugin.serializers = {
  htmlSerializer: htmlSerializer,
  textSerializer: textSerializer
};